import {
  MutableRefObject,
  RefObject,
  useEffect,
  useRef,
  useState,
} from 'react';

/** This custom hook is used to observe changes to Element's content */
export const useSizeObserver = (ref: RefObject<HTMLDivElement>): DOMRect => {
  const observer: MutableRefObject<any> = useRef(null);

  const [contentRect, setContentRect] = useState(
    ref.current ? ref.current.getBoundingClientRect() : {},
  );

  useEffect(() => {
    observer.current = new ResizeObserver((entries) => {
      setContentRect(entries[0].contentRect);
    });

    if (observer.current) {
      observer.current.observe(ref.current);
    }

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return contentRect as DOMRect;
};
